import type { IntlFormatters } from "@formatjs/intl";
import { ResponseCode } from "services/organizationPortalClient";

const translateError = (err: any, t: IntlFormatters["formatMessage"]) => {
  if (!err) return "";

  if (typeof err === "string") return t({ id: `error: ${err}` });

  if (err.message) return err.message;

  if (
    err?.data?.responseCode === ResponseCode.ValidationFailed ||
    err?.data?.responseCode === ResponseCode.BusinessRuleFailed
  )
    return err.data?.responseReason;

  return t({ id: "serverError" });
};

export default translateError;
